export default __webpack_public_path__ + "static/media/excelstep3.999d8d2e.png";